import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { object, string } from 'yup';

import { hasValue } from 'globalutils/fmUtils';

const Form = lazy(() =>
  import(`globalcomponents/UI/Form/${window?.$environment?.CURRENT_LAYOUT}`)
);

const MFAForm = ({
  apiStatus,
  authenticteOtp,
  clearApiStatus,
  Styled,
  innerComponent,
  i18n
}) => {
  const { LoginWrapper } = Styled;
  const t = i18n.t;
  const apiId = 'login';
  const hasApiStatus = hasValue(apiStatus.status, 'api', apiId);
  const RenderComponent = lazy(() => import(`@/${innerComponent}`));
  const NewUI = window?.$environment?.clutchNewUI;

  return (
    <LoginWrapper newUI={NewUI}>
      <div className="formLogin forgotPassword">
        <Suspense fallback={<div>Loading...</div>}>
          <Form
            type="server"
            direction="column"
            initialValues={{
              mfacode: ''
            }}
            RenderComponent={RenderComponent}
            handleOnSubmit={(fields) => {
              authenticteOtp({
                data: fields,
                apiId
              });
            }}
            customProps={{
              hasApiStatus,
              clearApiStatus,
              Styled,
              i18n
            }}
            validationSchema={object().shape({
              mfacode: string().required(t('common.fieldRequiredMessage'))
            })}
          />
        </Suspense>
      </div>
    </LoginWrapper>
  );
};

MFAForm.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  authenticteOtp: PropTypes.func.isRequired, 
  clearApiStatus: PropTypes.func.isRequired,
  Styled: PropTypes.object.isRequired,
  i18n: PropTypes.object.isRequired 
};

MFAForm.defaultProps = {
  apiStatus: {},
  Styled: {},
  i18n: {
    t: (key) => key 
  }
};

export default MFAForm;